import { HVACSystemDesign } from 'types';

export const calculateHVACSystemDesignTotalCost = (systemDesign: HVACSystemDesign): number => {
  const totalCost = systemDesign?.systems?.reduce((sum, system) => {
    return (
      sum +
      (parseFloat((system.equipment.totalCost as any) || 0) +
        parseFloat((system.accessories?.totalCost as any) || 0) +
        parseFloat((system.zoning?.totalCost as any) || 0) +
        parseFloat((system.sitePrep?.totalCost as any) || 0) -
        parseFloat((system.discounts?.totalCost as any) || 0))
    );
  }, 0);
  return Math.round((totalCost || 0) * 100) / 100;
};
